/**
 * Events URL slug per locale (i18n route first segment).
 * Must stay in sync with t_OGEVENTSSLUG in each locale JSON file.
 * Used by nuxt.config i18n custom routes so events paths are translated per locale
 * (e.g. /events/ in en, /evenements/ in fr) without affecting [propertyType] routes.
 */
export const EVENTS_SLUG_BY_LOCALE: Record<string, string> = {
  en: 'events',
  fr: 'evenements',
  de: 'veranstaltungen',
  es: 'eventos',
  it: 'eventi',
  pt: 'eventos',
  br: 'eventos',
  sv: 'evenemang',
  pl: 'wydarzenia',
  fi: 'tapahtumat',
  da: 'begivenheder',
  nl: 'evenementen',
  no: 'arrangementer',
  cs: 'akce',
  ru: 'meropriyatiya',
  tr: 'etkinlikler',
  zh: 'events',
  ja: 'events',
  ko: 'events',
};
